import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { UserStore } from '@core/stores';
import { QUERY_OPERATING_INTENTION } from '@core/modules/auth/data/constants';
import { StorageService } from '@core/shared/services';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  _,
) => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const storage = inject(StorageService);

  const isAuthActive = userStore.isAuthActive();

  if (!isAuthActive) {
    const hasParams = !!Object.entries(route?.queryParams || {})?.length;

    if (hasParams) {
      storage.setParam(QUERY_OPERATING_INTENTION, route.queryParams);
    }

    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }

  return true;
};
